(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar {
    constructor(track) {
      this.items = Array.from(track.querySelectorAll('.announcement__item'));
      if (this.items.length < 2) return;
      this.index = 0;
      this.timer = setInterval(() => this.next(), 5000);
    }
    next() {
      this.items[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.items.length;
      this.items[this.index].classList.add('is-active');
    }
  }
  document.querySelectorAll('.announcement__track').forEach((track) => new AnnouncementBar(track));

  // Publish the sticky announcement height so the header can offset itself and
  // the two bars stack cleanly. Resolves to 0 when the bar is absent or unpinned.
  function setAnnouncementHeight() {
    const sticky = document.querySelector('.announcement--sticky');
    const wrapper = document.querySelector('.announcement-section');
    const height = sticky && wrapper ? wrapper.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-height', height + 'px');
  }
  setAnnouncementHeight();
  window.addEventListener('resize', setAnnouncementHeight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Quantity steppers submit the cart form so totals stay accurate without AJAX.
  document.querySelectorAll('[data-cart-form] [data-qty]').forEach((stepper) => {
    const input = stepper.querySelector('[data-qty-input]');
    const form = stepper.closest('[data-cart-form]');
    const submit = () => form.requestSubmit ? form.requestSubmit() : form.submit();
    stepper.querySelector('[data-qty-minus]').addEventListener('click', () => {
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
      submit();
    });
    stepper.querySelector('[data-qty-plus]').addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 0) + 1;
      submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Close <details> overlays when the backdrop or close control is clicked,
  // and on Escape, so the header behaves like a modal without extra markup.
  document.querySelectorAll('[data-drawer], [data-search]').forEach((details) => {
    details.addEventListener('click', (event) => {
      if (event.target.closest('[data-drawer-close], [data-search-close]')) {
        details.removeAttribute('open');
      }
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('details[data-drawer][open], details[data-search][open]').forEach((d) =>
        d.removeAttribute('open')
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery {
    constructor(root) {
      this.stageItems = root.querySelectorAll('.pdp__stage-item');
      this.thumbs = root.querySelectorAll('.pdp__thumb');
      this.thumbs.forEach((thumb) =>
        thumb.addEventListener('click', () => this.show(thumb.dataset.thumb))
      );
    }
    show(mediaId) {
      this.stageItems.forEach((item) =>
        item.classList.toggle('is-active', item.dataset.mediaId === mediaId)
      );
      this.thumbs.forEach((thumb) =>
        thumb.classList.toggle('is-active', thumb.dataset.thumb === mediaId)
      );
    }
  }

  class VariantPicker {
    constructor(form) {
      this.form = form;
      const json = form.closest('.pdp')?.querySelector('[data-variant-json]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.idSelect = form.querySelector('[data-variant-id]');
      this.priceNow = form.closest('.pdp').querySelector('[data-price-now]');
      this.priceCompare = form.closest('.pdp').querySelector('[data-price-compare]');
      this.addButton = form.querySelector('[data-add-button]');
      this.addText = form.querySelector('[data-add-text]');
      form.querySelectorAll('[data-option-value]').forEach((input) =>
        input.addEventListener('change', () => this.onChange())
      );
    }
    selectedOptions() {
      return Array.from(this.form.querySelectorAll('[data-option-value]:checked')).map((i) => i.value);
    }
    onChange() {
      const selected = this.selectedOptions();
      const match = this.variants.find(
        (v) => v.options.length === selected.length && v.options.every((o, i) => o === selected[i])
      );
      // reflect selected value labels
      this.form.querySelectorAll('.pdp__option').forEach((fs) => {
        const idx = fs.dataset.optionIndex;
        const checked = fs.querySelector('[data-option-value]:checked');
        const label = this.form.querySelector(`[data-option-selected="${idx}"]`);
        if (label && checked) label.textContent = checked.value;
      });
      if (!match) {
        this.setUnavailable(this.addButton.dataset.textUnavailable);
        return;
      }
      if (this.idSelect) this.idSelect.value = match.id;
      if (this.priceNow) this.priceNow.textContent = match.price;
      if (this.priceCompare) {
        this.priceCompare.style.display = match.compare_raw > 0 ? '' : 'none';
        this.priceCompare.textContent = match.compare_at;
      }
      if (match.available) {
        this.addButton.disabled = false;
        this.addText.textContent = this.addButton.dataset.textAdd;
      } else {
        this.setUnavailable(this.addButton.dataset.textSoldout);
      }
    }
    setUnavailable(text) {
      this.addButton.disabled = true;
      this.addText.textContent = text;
    }
  }

  class QuantityStepper {
    constructor(root) {
      this.input = root.querySelector('[data-qty-input]');
      root.querySelector('[data-qty-minus]').addEventListener('click', () => this.step(-1));
      root.querySelector('[data-qty-plus]').addEventListener('click', () => this.step(1));
    }
    step(delta) {
      const next = Math.max(1, (parseInt(this.input.value, 10) || 1) + delta);
      this.input.value = next;
    }
  }

  document.querySelectorAll('[data-gallery]').forEach((el) => new ProductGallery(el));
  document.querySelectorAll('.pdp__form').forEach((el) => new VariantPicker(el));
  document.querySelectorAll('[data-qty]').forEach((el) => new QuantityStepper(el));

  } catch(e) { console.error(e); }
})();
})();
